import { useState } from "react";
import { RotateArrow } from "./arrow";
import * as Styled from "./style";
import { MenuNameWithNewTag } from "~/components/blocks/layout/global-navi/mobile/left/dmm-service/menu-name-with-new-tag";
import { sendTrackingClickCommon } from "~/lib/tracking/events";

type AccordionProps = {
  children: React.ReactNode;
  title: string;
  name: string;
  src: string;
  defaultIsOpen?: boolean;
  viaViewRank: number;
  viaTargetId: string;
  isNew: boolean;
};

export const Accordion = ({
  children,
  title,
  src,
  name,
  defaultIsOpen = false,
  viaViewRank,
  viaTargetId,
  isNew,
}: AccordionProps) => {
  const [isOpen, setIsOpen] = useState(defaultIsOpen);

  return (
    <Styled.LIWrapper>
      <Styled.DivListContent
        onClick={() => {
          setIsOpen((prev) => !prev);
          sendTrackingClickCommon({ clickEventName: "dmmtv_navigation", viaTargetId, viaViewRank });
        }}
        role="button"
        aria-label={`${title}のサブカテゴリー一覧を${isOpen ? "閉じる" : "開く"}`}
      >
        <Styled.DivTextWrapper>
          <Styled.LazyImage width="30px" height="30px" src={src} alt={name} />
          <Styled.SpanMenuNameWithNewTagWrapper>
            <MenuNameWithNewTag menuName={title} isNew={isNew} isHeading={true} />
          </Styled.SpanMenuNameWithNewTagWrapper>
        </Styled.DivTextWrapper>
        <RotateArrow isOpen={isOpen} />
      </Styled.DivListContent>

      <Styled.NavAccordionItem isOpen={isOpen} aria-hidden={!isOpen}>
        <Styled.ULWrapper>{children}</Styled.ULWrapper>
      </Styled.NavAccordionItem>
    </Styled.LIWrapper>
  );
};
